var _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { G, Circle } from "react-native-svg";
function SvgIconTitleArrow(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#5B41F0",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 1.471,
    cy: 1.824,
    r: 1.471
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 1.471,
    cy: 10.333,
    r: 1.471
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 5.471,
    cy: 6.333,
    r: 1.471
  }))));
}
export default SvgIconTitleArrow;